
export const isExecutive = (session) => {
    if (!session || !session.department) {
        return false;
    }
    const department = session.department.toLowerCase();
    return department === "executive"
}

export const isFulfillment = (session) => {
    if (!session || !session.department) {
        return false;
    }
    const department = session.department.toLowerCase();
    return department === "fulfillment"
}

export const setPermissions = (session) => {
    // set a permission table for the session
    if (!session || !session.department) {
        return false;
    }
    const department = session.department.toLowerCase();
    switch (department) {
        case 'sales':
            session.permissions = {
                sales: true,
                fulfillment: true,
                inventory: true,
                accounting: false,
                executive: false,
                allTask: false,
                cultivation: false,
                manufacturing: false,
                operations: false,
                graphics: false,
                trapconretail: false
            }
            break;
        case 'operations':
            session.permissions = {
                sales: true,
                fulfillment: true,
                inventory: true,
                accounting: false,
                executive: false,
                allTask: true,
                cultivation: true,
                manufacturing: true,
                operations: true,
                graphics: true,
                trapconretail: true
            }
            break;
        case 'accounting':
            session.permissions = {
                sales: true,
                fulfillment: false,
                inventory: true,
                accounting: true,
                executive: false,
                allTask: false,
                cultivation: false,
                manufacturing: false,
                operations: false,
                graphics: false,
                trapconretail: false,
            }
            break;
        case 'executive':
            session.permissions = {
                sales: true,
                fulfillment: true,
                inventory: true,
                accounting: true,
                executive: true,
                allTask: true,
                cultivation: true,
                manufacturing: true,
                operations: true,
                graphics: true,
                trapconretail: true,
            }
            break;
        case 'fulfillment':
            session.permissions = {
                sales: false,
                fulfillment: true,
                inventory: true,
                accounting: false,
                executive: false,
                allTask: false,
                cultivation: false,
                manufacturing: false,
                operations: false,
                graphics: false,
                trapconretail: false,
            }
            break;
        case 'cultivation':
            session.permissions = {
                sales: false,
                fulfillment: false,
                inventory: false,
                accounting: false,
                executive: false,
                allTask: false,
                cultivation: true,
                manufacturing: false,
                operations: false,
                graphics: false,
                trapconretail: false
            }
            break;
        case 'manufacturing':
            session.permissions = {
                sales: false,
                fulfillment: false,
                inventory: false,
                accounting: false,
                executive: false,
                allTask: false,
                cultivation: false,
                manufacturing: true,
                operations: false,
                graphics: false,
                trapconretail: false
            }
            break;
        case 'graphics':
            session.permissions = {
                sales: false,
                fulfillment: false,
                inventory: false,
                accounting: false,
                executive: false,
                allTask: false,
                cultivation: false,
                manufacturing: true,
                operations: false,
                graphics: true,
                trapconretail: false
            }
            break;
        case 'trapconretailnordhoff':
            session.permissions = {
                sales: false,
                fulfillment: false,
                inventory: false,
                accounting: false,
                executive: false,
                allTask: false,
                cultivation: false,
                manufacturing: false,
                operations: false,
                graphics: false,
                trapconretail: true
            }
            break;
        default:
            break;
    }
}

export const checkPerm = (session, role) => {
    if (!session || !session.permissions) {
        return false;
    }

    return session.permissions[role] === true;
}